module.exports = __webpack_public_path__ + "static/media/15.ec0bf9b2.jpg";